import $ from 'cash-dom';
import svg4everybody from 'svg4everybody';


import header from './components/header';
import inpageScroll from './components/inpageScroll';
import activateItems from './components/sections';

svg4everybody();

$(document).ready(() => {
  header();
  inpageScroll();
  activateItems();
});
